(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (document.documentElement.dataset.productCardInitialized === 'true') return;
    document.documentElement.dataset.productCardInitialized = 'true';

    document.addEventListener('click', (event) => {
      const arrow = event.target.closest('.product-card__arrow');
      if (!arrow) return;
      event.preventDefault();
      const media = arrow.closest('.product-card__media');
      const images = [...media.querySelectorAll('.product-card__image')];
      if (images.length < 2) return;
      let index = images.findIndex((img) => img.classList.contains('is-active'));
      if (index === -1) index = 0;
      images[index].classList.remove('is-active');
      const direction = arrow.dataset.direction === 'next' ? 1 : -1;
      index = (index + direction + images.length) % images.length;
      images[index].classList.add('is-active');
    });

    const updateCartCount = async (root) => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;

      const cart = await response.json();
      for (const count of document.querySelectorAll('.site-header__cart-count')) {
        count.textContent = cart.item_count;
      }

      for (const link of document.querySelectorAll('[data-header-cart-link]')) {
        const label = link.querySelector('[data-header-cart-label]');
        if (label) label.textContent = `${link.dataset.cartLabel} (${cart.item_count})`;
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    };

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.product-card__form');
      if (!form) return;

      event.preventDefault();
      const button = form.querySelector('[data-product-card-submit]');
      if (!button || button.disabled || button.dataset.submitting === 'true') return;

      const defaultText = button.dataset.defaultText;
      const label = button.querySelector('.product-card__atc-label');
      const root = window.Shopify?.routes?.root || '/';

      button.dataset.submitting = 'true';
      button.disabled = true;
      button.classList.remove('is-added', 'is-error');
      button.classList.add('is-loading');
      button.setAttribute('aria-label', button.dataset.addingText);

      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('Unable to add product');

        button.classList.remove('is-loading');
        button.classList.add('is-added');
        button.setAttribute('aria-label', button.dataset.addedText);
        if (label) label.textContent = button.dataset.addedText;
        await updateCartCount(root).catch(() => {});

        window.setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
          button.dataset.submitting = 'false';
          button.removeAttribute('aria-label');
          if (label) label.textContent = defaultText;
        }, 1400);
      } catch (error) {
        button.classList.remove('is-loading');
        button.classList.add('is-error');
        button.setAttribute('aria-label', button.dataset.errorText);
        if (label) label.textContent = button.dataset.errorText;

        window.setTimeout(() => {
          button.classList.remove('is-error');
          button.disabled = false;
          button.dataset.submitting = 'false';
          button.removeAttribute('aria-label');
          if (label) label.textContent = defaultText;
        }, 1800);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
